import { EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA } from "domain/entity/TransferOfCharge/TransferOfChargeBulkEditCriteria";
import _ from "lodash";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { TransferOfChargeConstant } from "presentation/constant/TransferOfCharge/TransferOfChargeConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useTransferOfChargeVM } from "presentation/hook/TransferOfCharge/useTransferOfChargeVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useTransferOfChargeTracked } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { OverflowMenuButton } from "presentation/view/components/OverflowMenuButton";
import { memo, useCallback, useMemo, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const TransferOfChargeTitleBar: React.FC = () => {
    const [transferOfChargeState] = useTransferOfChargeTracked();
    const transferOfChargeVM = useTransferOfChargeVM();
    const [isLoading, setIsLoading] = useState(false);
    const { transferOfChargeList, selectedRows, searchCriteria, isShowEditPanel } = transferOfChargeState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate, operatingUnit } = anaInfoState;

    const handleConfirmClick = useCallback(async () => {
        if (selectedRows.length === 0) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        const ids = selectedRows.map(entity => entity.id);

        let soNumberList: string[] = [];
        selectedRows.forEach(item => {
            if (item.shippingBill && !soNumberList.includes(item.shippingBill)) {
                soNumberList.push(item.shippingBill);
            }
        })
        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            let errorMsg = "";
            if (soNumberList && soNumberList.length > 0) {
                await transferOfChargeVM.checkBookingChargeCntr(ids).then(async (data) => {
                    if (data && !data.success) {
                        errorMsg = "Booking or Booking container number is updated/removed in ngen!";
                        transferOfChargeVM.onSearch(searchCriteria);
                        messageBarVM.showError(errorMsg);
                    }
                });
            }
            if (errorMsg) {
                return;
            }
        }

        setIsLoading(true);
        transferOfChargeVM.onConfirmAndSubmit(ids).then((data) => {
            if (data && data.success) {
                transferOfChargeVM.onSearch(searchCriteria).then((data) => {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Confirm successfully.");
                })
            } else {
                setIsLoading(false);
                messageBarVM.showError(data.data);
            }
        }).catch(error => {
            setIsLoading(false);
        });

    }, [messageBarVM, operatingUnit, searchCriteria, selectedRows, transferOfChargeVM]);

    const handleApplyClick = useCallback(async () => {
        setIsLoading(true);
        const ids = transferOfChargeList.map(entity => entity.id);
        transferOfChargeVM.onApply(ids).then((data) => {
            if (data && data.success) {
                transferOfChargeVM.onSearch(searchCriteria).then((data) => {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Apply successfully.");
                })
            } else {
                setIsLoading(false);
                messageBarVM.showError(data.data);
            }
        }).catch(error => {
            setIsLoading(false);
        });

    }, [messageBarVM, searchCriteria, transferOfChargeList, transferOfChargeVM]);

    const vaildationForUpdateBillToChargeOn = useCallback(async () => {
        if (selectedRows.length < 1) {
            return 'Please select a record.';
        }

        let hasT = false;
        let hasMT = false;
        let hasH = false;
        let hasI = false;
        let hasMH = false;
        let hasSH = false;
        let hasDI = false;
        let hasSA = false;
        let hasADRE = false;
        selectedRows.forEach(entity => {
            if (entity.dtlState === 'I') {
                hasI = true;
            } else if (entity.dtlState === 'T') {
                hasT = true;
            } else if (entity.dtlState === 'MT') {
                hasMT = true;
            } else if (entity.dtlState === 'SH') {
                hasSH = true;
            } else if (entity.dtlState === 'MH') {
                hasMH = true;
            } else if (entity.dtlState === 'H') {
                hasH = true;
            } else if (entity.dtlState === 'DI') {
                hasDI = true;
            } else if (entity.dtlState === 'SA') {
                hasSA = true;
            } else if (entity.dtlState === 'AD' || entity.dtlState === 'RE') {
                hasADRE = true;
            }
        });
        if (hasH || hasI || hasMH || hasMT || hasSH || hasT || hasDI || hasSA || hasADRE) {
            return 'Just allow update Charge-On/Bill-To Company for TOC/F/E/T and waiver approved charge.';
        }
        return null;

    }, [selectedRows]);

    const vaildationForUpdate = useCallback(async (isPaidThroughDate: boolean) => {
        let isAllowUpdatePaidThroughDate = false;
        let hasMT = false;
        let hasH = false;
        let hasI = false;
        let hasMH = false;
        let hasSH = false;
        let hasDI = false;
        let hasSA = false;
        let hasSG = false;
        let hasW = false;
        if (selectedRows.length < 1) {
            return 'Please select a record.';
        }
        selectedRows.forEach(entity => {
            if (entity.dtlState === 'I') {
                hasI = true;
            } else if (entity.dtlState === 'F') {
            } else if (entity.dtlState === 'T') {
            } else if (entity.dtlState === 'MT') {
                hasMT = true;
            } else if (entity.dtlState === 'SH') {
                hasSH = true;
            } else if (entity.dtlState === 'MH') {
                hasMH = true;
            } else if (entity.dtlState === 'H') {
                hasH = true;
            } else if (entity.dtlState === 'DI') {
                hasDI = true;
            } else if (entity.dtlState === 'SA') {
                hasSA = true;
            } else if (entity.dtlState === 'SG') {
                hasSG = true;
            } else if (entity.dtlState === 'W') {
                hasW = true;
            }
            if (isPaidThroughDate && (entity.dtlState === 'E' || entity.dtlState === 'R' || entity.dtlState === 'F'
                || entity.dtlState === 'T' || entity.dtlState === 'W' || entity.dtlState === 'TOC')) {
                if (entity.chargeType === 'ITM'
                    || (entity.chargeType === 'CC' && entity.subChargeType === 'ITM')
                    || (entity.chargeType === 'DEM' && entity.subChargeType === 'DEI')
                    || ('RFH' === entity.getChargeType &&
                        ('PCI' === entity.getSubChargeType ||
                            'FDC' === entity.getSubChargeType ||
                            (("IF" === entity.getCntrStatus1 || "IM" === entity.getCntrStatus1 || "TF" === entity.getCntrStatus1 || "TM" === entity.getCntrStatus1)
                                && ('T2' === entity.getSubChargeType || ('T1' === entity.getSubChargeType && entity.getOtherSplitId == null)))))
                    || ('CSR' === entity.chargeType && ('ST' === entity.subChargeType || 'DE' === entity.subChargeType))
                ) {
                    isAllowUpdatePaidThroughDate = true;
                }
            }
        });
        if (!isPaidThroughDate) {
            if (hasH || hasI || hasMH || hasMT || hasSH || hasDI || hasSA || hasSG || hasW) {
                return 'Just allow update Excise Cash No. for TOC/F/E/T and waiver approved charge.';
            }
        }
        if (isPaidThroughDate && !isAllowUpdatePaidThroughDate) {
            return 'Just allow update the paid through date for TOC/F/E/T storage charge except for outbound storage.';
        }
        return null;

    }, [selectedRows]);


    const handleEditClick = useCallback(async () => {
        const isUptPaidThroughDate = await vaildationForUpdate(true) ? false : true;
        const isUptExciseCashNo = await vaildationForUpdate(false) ? false : true;
        const ids = selectedRows.map(entity => entity.id);
        transferOfChargeVM.onEditClick(true, false, false, isUptExciseCashNo, isUptPaidThroughDate, ids);
    }, [selectedRows, transferOfChargeVM, vaildationForUpdate]);

    const handleSearch = useCallback(async () => {
        transferOfChargeVM.onSearchClick();
    }, [transferOfChargeVM]);

    const isConfirmDisable = () => {
        if (selectedRows.length > 0 && !isShowEditPanel) return false
        return true;
    }
    const isApplyDisable = () => {
        if (transferOfChargeList.length > 0 && !isShowEditPanel) return false
        return true;
    }
    const isEditDisable = () => {
        if (selectedRows.length > 0 && !isShowEditPanel && selectedRows.every(ety => ety.dtlState === 'R' || ety.dtlState === 'E' || ety.dtlState === 'F' || ety.dtlState === 'TOC')) return false
        return true;
    }

    // const isUpdateDisable = () => {
    //     if (selectedRows.length > 0 && !isShowEditPanel) return false
    //     return true;
    // }

    const handleAccTmlResume = useCallback(async () => {
        if (selectedRows.length === 0) {
            messageBarVM.showError(MessageConstant.common.SELECT_A_RECORD_AT_LEAST);
        } else {
            let stateArr: string[] = ["I", "DI", "H", "MH", "C"];
            let bool = false;
            let enableRowCount = 0;
            let showAccReasonCodePanel = true;
            for (let charge of selectedRows) {
                if (charge.dtlState && stateArr.includes(charge.dtlState)) {
                    bool = true;
                    break;
                }
                if (charge.dtlState === "MT" || charge.dtlState === "T" || charge.dtlState === "R" || charge.dtlState === "E" || charge.dtlState === "F") {
                    enableRowCount++;
                }

                if (charge.dtlState === "T" || charge.dtlState === "MT") {
                    showAccReasonCodePanel = false;
                }
            }
            if (bool) {
                messageBarVM.showError(stateArr + ' state charge can not do current operation!');
            } else {
                if (selectedRows.length === enableRowCount) {

                    if (showAccReasonCodePanel) {

                        transferOfChargeVM.showAccTmlReasonCodePanel(selectedRows.map(e => e.id))

                    } else {
                        setIsLoading(true);

                        try {
                            const res = await transferOfChargeVM.onAccTmlResume({
                                ...EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA,
                                ids: selectedRows.map(e => e.id),
                                accTmlResume: true,
                            });
                            if (!!!res || !res.success) {
                                res?.data && messageBarVM.showError(res?.data ?? 'Account Terminal Resume Failed.');
                            } else {
                                transferOfChargeVM.onSearch(searchCriteria);
                            }
                        } catch (error) {
                            messageBarVM.showError('Account Terminal Resume Failed.');
                        } finally {
                            setIsLoading(false)
                        }
                    }
                }
            }
        }
    }, [messageBarVM, searchCriteria, selectedRows, transferOfChargeVM]);

    const handleHoldAndUnHold = useCallback(async () => {
        if (selectedRows.length === 0) {
            messageBarVM.showError(MessageConstant.common.SELECT_A_RECORD_AT_LEAST);
        } else {
            let stateArr: string[] = ["I", "DI", "T", "MT", "MH", "C"];
            let bool = false;
            let enableRowCount = 0;
            for (let charge of selectedRows) {
                if (charge.dtlState && stateArr.includes(charge.dtlState)) {
                    bool = true;
                    break;
                }
                if (charge.dtlState === "H" || charge.dtlState === "R" || charge.dtlState === "E" || charge.dtlState === "F") {
                    enableRowCount++;
                }
            }
            if (bool) {
                messageBarVM.showError(stateArr + ' state charge can not do current operation!');
            } else {
                if (selectedRows.length === enableRowCount) {


                    setIsLoading(true);
                    try {
                        const res = await transferOfChargeVM.onHoldUnHold({
                            ...EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA,
                            ids: selectedRows.map(e => e.id),
                            holdOrUnHold: true,
                        });
                        if (!!!res || !res.success) {
                            res?.data && messageBarVM.showError(res?.data ?? 'Hold / Un-Hold Failed.');
                        } else {
                            transferOfChargeVM.onSearch(searchCriteria);
                        }
                    } catch (error) {
                        messageBarVM.showError('Hold / Un-Hold Failed.');
                    } finally {
                        setIsLoading(false)
                    }

                }
            }
        }

    }, [messageBarVM, searchCriteria, selectedRows, transferOfChargeVM]);

    const handleUptBillToCompanyClick = useCallback(async () => {
        const isUpt = await vaildationForUpdateBillToChargeOn();
        if (isUpt) {
            messageBarVM.showError(isUpt);
            return;
        }
        const ids = selectedRows.map(entity => entity.id);
        transferOfChargeVM.onEditClick(false, true, false, false, false, ids);

    }, [messageBarVM, selectedRows, transferOfChargeVM, vaildationForUpdateBillToChargeOn]);

    const handleUptChargeOnCompanyClick = useCallback(async () => {
        const isUpt = await vaildationForUpdateBillToChargeOn();
        if (isUpt) {
            messageBarVM.showError(isUpt);
            return;
        }
        const ids = selectedRows.map(entity => entity.id);
        transferOfChargeVM.onEditClick(false, false, true, false, false, ids);

    }, [messageBarVM, selectedRows, transferOfChargeVM, vaildationForUpdateBillToChargeOn]);

    const handleUptPaidThroughDateClick = useCallback(async () => {
        const isUptPaidThroughDate = await vaildationForUpdate(true);
        if (isUptPaidThroughDate) {
            messageBarVM.showError(isUptPaidThroughDate);
            return;
        }
        const ids = selectedRows.map(entity => entity.id);
        transferOfChargeVM.onEditClick(false, false, false, false, true, ids);

    }, [messageBarVM, selectedRows, transferOfChargeVM, vaildationForUpdate]);

    const handleUptExciseCashNoClick = useCallback(async () => {
        const isUptExciseCashNo = await vaildationForUpdate(false);
        if (isUptExciseCashNo) {
            messageBarVM.showError(isUptExciseCashNo);
            return;
        }
        const ids = selectedRows.map(entity => entity.id);
        transferOfChargeVM.onEditClick(false, false, false, true, false, ids);

    }, [messageBarVM, selectedRows, transferOfChargeVM, vaildationForUpdate]);

    const memoBulkEditMenu = useMemo(() => {
        let menuItems = [
            {
                seq: 100,
                title: 'Update Bill-To Company',
                disabled: false,
                command: () => {
                    handleUptBillToCompanyClick();
                }
            },
            {
                seq: 200,
                title: 'Update Charge-On Company',
                disabled: false,
                command: () => {
                    handleUptChargeOnCompanyClick();
                }
            },
            {
                seq: 300,
                title: 'Update Paid Through Date',
                command: () => {
                    handleUptPaidThroughDateClick();
                }
            }

        ]

        if (operatingUnit !== 'AQCT' && operatingUnit !== 'RSCT') {
            menuItems.push(
                {
                    seq: 400,
                    title: 'Update Excise Cash No.',
                    command: () => {
                        handleUptExciseCashNoClick();
                    }
                }
            )
        } else {
            menuItems.push(
                {
                    seq: 30,
                    title: 'Account Terminal / Resume',
                    disabled: !transferOfChargeState.accResumeTerminalEnable,
                    command: () => {
                        handleAccTmlResume();
                    }
                },
                {
                    seq: 50,
                    title: 'Hold / Un-Hold',
                    disabled: !transferOfChargeState.holdUnHoldEnable,
                    command: () => {
                        handleHoldAndUnHold();
                    }
                }
            )
        }

        return _.sortBy(menuItems, 'seq', 'desc');

    }, [handleAccTmlResume, handleHoldAndUnHold, handleUptBillToCompanyClick, handleUptChargeOnCompanyClick, handleUptExciseCashNoClick, handleUptPaidThroughDateClick, operatingUnit, transferOfChargeState.accResumeTerminalEnable, transferOfChargeState.holdUnHoldEnable]);


    const memoMoreIconButton = useMemo(() => {
        let disabled: boolean = false;
        if (isShowEditPanel) {
            disabled = true;
        }
        return <OverflowMenuButton buttonLabel={WorkspaceConstant.Common.BUTTON_MORE} disabled={disabled}
            toolTipText={WorkspaceConstant.Common.BUTTON_MORE} navigationList={memoBulkEditMenu} buttonSize={"Small"} buttonTheme={"Secondary"} />
    }, [isShowEditPanel, memoBulkEditMenu])

    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{TransferOfChargeConstant.TITLE}</HeaderTitle>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
            <div className="add-seperator" />
            {/* {(allowUpdate) && <HPHButton disabled={isUpdateDisable()} label={'Update Excise Cash No.'} size={'Small'} theme={'Secondary'} onClick={handleUptExciseCashNoClick} />}
            {(allowUpdate) && <HPHButton disabled={isUpdateDisable()} label={'Update Paid Through Date'} size={'Small'} theme={'Secondary'} onClick={handleUptPaidThroughDateClick} />} */}
            {(allowUpdate) && <HPHButton disabled={isApplyDisable()} label={WorkspaceConstant.Common.BUTTON_APPLYALL} size={'Small'} theme={'Secondary'} onClick={handleApplyClick} />}
            {(allowUpdate) && <HPHButton disabled={isConfirmDisable()} label={WorkspaceConstant.Common.BUTTON_CONFIRM_SUBMIT} size={'Small'} theme={'Primary'} onClick={handleConfirmClick} />}
            {(allowUpdate) && <><div className="add-seperator" />
                <IconButton fileName='Icon-pen' disabled={isEditDisable()} size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEditClick} /></>}
            {(allowUpdate) && memoMoreIconButton}
        </StyledAction>
        {transferOfChargeState.forceRefresh && <></>}
    </Sidebarheader>
}

export default memo(TransferOfChargeTitleBar);